import { Environment } from 'types';

export const environmentSurface: Record<
  Environment,
  { backgroundColor: string; borderColor: string; color: string }
> = {
  live: {
    backgroundColor: '$green100',
    borderColor: '$green300',
    color: '$green900',
  },
  'pre-live': {
    backgroundColor: '$violet100',
    borderColor: '$violet300',
    color: '$violet900',
  },
};

export const environmentDot: Record<Environment, string> = {
  live: '$green700',
  'pre-live': '$violet700',
};

export const environmentLabel: Record<Environment, string> = {
  live: 'Live',
  'pre-live': 'Pre-live',
};
